import { auth, db ,serverTimestamp} from "./firebase";
import React ,{useState,useEffect}from 'react'
import './Send.css'
import firebase from './firebase';
import { useStateValue } from './StateProvider'
import { v4 as uuidv4 } from "uuid";
function Send() {
    const [msgin,setMsgin]=useState('')
    const [{ user },dispatch]= useStateValue();
    
  
    const sendMessage=(e)=>{
        e.preventDefault()
        const uid =uuidv4()
        const date = new Date()
        
        db.collection("Messages").doc(uid).set({
            id:uid,
        Message: msgin,
        Uname:user.displayName ,
        timestamp:firebase.firestore.FieldValue.serverTimestamp()
    }).then(()=>{
       
    }).catch((error)=>{
        alert(error.message)
    })
    setMsgin("")
    }

    const handlekp =(e)=>{
        if(e.keyCode === 13){
            sendMessage()
            e.preventDefault();
        }
    }
    
    return (
        <div className="send_main">
            <div className="send_box">
                <form action=""> 
                 <input onKeyPress={handlekp} placeholder="Enter Message Here " autoFocus type="text" value={msgin} onChange={e=>setMsgin(e.target.value)} />
                </form>
               
            </div>
            <div className="send_btn">
                <button  type="submit" onClick={sendMessage}>Send</button>
            </div>
        </div>
    )
}

export default Send
